var render, staticRenderFns
import script from "./h-content-body.vue?vue&type=script&lang=js"
export * from "./h-content-body.vue?vue&type=script&lang=js"
import style0 from "./h-content-body.vue?vue&type=style&index=0&id=6578f420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6578f420",
  null
  
)

export default component.exports